import React, { useEffect, useState } from "react";

import { RequireUserAuth, useUserContext, useUserDispatchContext } from "../context/User";
import { getUserPets, removeUserPets } from "../services/api";
import { getFemaleIcon, getMaleIcon } from "../services/icons";
import { PetAPIResponseType } from "../types/pet";
import Button from "./Button";
import SideBarContent from "./SideBarContent";
import SideBarFooter from "./SideBarFooter";

const staticUrl: string = process.env.STATIC_URL;

type PropsType = {
  onCloseHandle?: () => void;
};

function UserPageDogs({ onCloseHandle }: PropsType) {
  const [loading, setLoading] = useState(true);
  const [pets, setPets] = useState([] as PetAPIResponseType[]);
  const [selected, setSelected] = useState([] as string[]);

  const { user } = useUserContext();
  const userDispatch = useUserDispatchContext();

  useEffect(() => {
    if (!user.accessToken) {
      return;
    }

    fetchUserPets();
  }, [user.accessToken]);

  useEffect(() => {
    console.log("selected", selected);
  }, [selected]);

  const fetchUserPets = () => {
    if (!user.accessToken) {
      return;
    }

    getUserPets(user.accessToken)
      .then((data) => {
        if (!data) {
          return;
        }
        setPets(data);
      })
      .catch((e) => console.log(e))
      .finally(() => setLoading(false));
  };

  const deletePets = () => {
    if (!user.accessToken || !selected.length) {
      return;
    }

    removeUserPets(user.accessToken, selected)
      .then((data) => {
        console.log(data);
        setSelected([]);
        fetchUserPets();
      })
      .catch((e) => console.log(e));
  };

  const renderFooter = () => {
    if (!selected.length) {
      return null;
    }
    return (
      <SideBarFooter>
        <div className="flex flex-row items-center justify-between gap-4">
          <div>
            {selected.length > 0 && (
              <>
                <span className="font-barlowmedium">{selected.length}</span>{" "}
                <span className="font-barlowlight">dogs selected</span>
              </>
            )}
          </div>

          <div className="flex flex-row items-center gap-4">
            <div
              onClick={() => setSelected([])}
              className="cursor-pointer font-simianregular text-[18px]"
            >
              Unselect all
            </div>
            <Button title="Remove" onClick={deletePets} theme="red" />
          </div>
        </div>
      </SideBarFooter>
    );
  };

  const renderGenderIcon = (gender: string) => {
    if (gender === "female") {
      return getFemaleIcon("#0B0B0B");
    } else {
      return getMaleIcon("#0B0B0B");
    }
  };

  const updateSelectedPets = (id: string) => {
    let list = [...selected];
    const isSelected = list.includes(id);
    if (isSelected) {
      list = list.filter((s) => s !== id);
    } else {
      list.push(id);
    }

    setSelected(list);
  };

  const onEditDoghandle = (id: string) => {
    userDispatch({
      type: "set-page",
      payload: { page: "edit-dog", pageParams: { id: id } },
    });
  };

  if (loading) {
    return;
  }

  return (
    <>
      <SideBarContent>
        {pets && pets.length > 0 && (
          <>
            <div className="mb-6 font-barlowlight text-[12px]">{pets.length} dogs</div>
            <div className="grid grid-cols-2 gap-6 lg:grid-cols-4 xl:grid-cols-5">
              {pets.map((pet) => {
                const dt = new Date(pet.createdAt);
                const date = `${dt.getDate()} ${dt.toLocaleString("en-US", {
                  month: "short",
                })} ${dt.getFullYear()}`;
                return (
                  <div key={pet.id}>
                    <div>
                      <div className="relative">
                        <img
                          src={`${staticUrl}${pet.images[0].url}`}
                          className="h-[180px] w-full cursor-pointer object-cover"
                          onClick={() => onEditDoghandle(pet.id)}
                        />
                        <div className="absolute left-[10px] top-[10px]">
                          <label
                            className="relative flex cursor-pointer items-center p-1"
                            htmlFor={`check-${pet.id}`}
                          >
                            <input
                              id={`check-${pet.id}`}
                              type="checkbox"
                              // value={el.value}
                              // name={name}
                              onChange={() => updateSelectedPets(pet.id)}
                              checked={selected.includes(pet.id)}
                              style={{
                                WebkitAppearance: "none",
                                MozAppearance: "none",
                              }}
                              className={`before:content[''] peer relative h-6 w-6 cursor-pointer appearance-none rounded-[4px] border border-[#727272] bg-white transition-all before:absolute before:left-2/4 before:top-2/4 before:block before:h-6 before:w-6 before:-translate-x-2/4 before:-translate-y-2/4 before:rounded-[4px] before:opacity-0 before:transition-opacity checked:border-[#727272] checked:bg-black hover:before:opacity-10`}
                            />
                            <div className="text-theme-primary3 pointer-events-none absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 opacity-0 transition-opacity peer-checked:opacity-100">
                              <svg
                                width="12"
                                height="10"
                                viewBox="0 0 12 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1 6L4 9L11 1"
                                  stroke="white"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>
                          </label>
                        </div>
                      </div>
                      <div
                        className="cursor-pointer border-[1px] border-t-0 border-[#EEEEEE] p-3"
                        onClick={() => onEditDoghandle(pet.id)}
                      >
                        <div className="flex flex-row items-center gap-2">
                          <div className="font-barlowmedium text-[20px] text-[#0B0B0B]">
                            {pet.name}
                          </div>

                          {renderGenderIcon(pet.gender)}
                        </div>
                        <div className="mb-3 font-barlowregular text-[12px] text-[#474747]">
                          {pet.petCode}
                        </div>
                        <div className="font-barlowregular text-[12px] text-[#0B0B0B]">
                          Date added: <span className="font-barlowmedium">{date}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </SideBarContent>
      {renderFooter()}
    </>
  );
}

export default function UserPageDogsWrapper(props: PropsType) {
  return (
    <RequireUserAuth>
      <UserPageDogs {...props} />
    </RequireUserAuth>
  );
}
